import Quote from "@src/app/assets/icons/quote.svg?react";
import type { BFFArticleBodyElement } from "@src/app/types/bff";

import ArticleAnnotation from "./components/ArticleAnnotation";

export default function ArticlePullQuote({
  element,
}: {
  element?: BFFArticleBodyElement["pull_quote"];
}) {
  console.log(element, "element");

  return (
    <div className="flex items-start gap-5 pb-4">
      <div className="text-icon-brand">
        <Quote width={28} height={28} />
      </div>

      <p className="py-1 text-justify text-header-3 text-primary">
        <ArticleAnnotation
          value={element?.quote || ""}
          annotations={element?.quoteAnnotations || []}
        />
      </p>
    </div>
  );
}
